import React from 'react';

import CompanyLogo from 'app/components/CommonStyled/CompanyLogo';
import { PulseLeadIcon } from 'app/components/DetailsPages/shared/CommonGround/Icons';
import { IResource } from 'app/components/Resources/ResourceCard';
import dayjs from 'dayjs';
import { arrayToOxford } from 'utils';

import {
  ContributorsWithCompaniesCompanyContainer,
  ContributorsWithCompaniesCompanyWrapper,
  ContributorsWithCompaniesDate,
  ContributorsWithCompaniesInformation,
  ContributorsWithCompaniesNames,
  ContributorsWithCompaniesNamesContainer,
  ContributorsWithCompaniesWrapper,
} from './styled';

interface ContributorsWithCompaniesProps {
  resource: IResource;
}

export default function ContributorsWithCompanies({ resource }: ContributorsWithCompaniesProps) {
  return (
    <>
      <ContributorsWithCompaniesWrapper>
        <ContributorsWithCompaniesCompanyWrapper>
          <ContributorsWithCompaniesCompanyContainer>
            {resource?.contributors?.companies?.map((company) => (
              <CompanyLogo key={company.slug} size={72} slug={company.slug} openDrawer useRounded />
            ))}
          </ContributorsWithCompaniesCompanyContainer>
          <ContributorsWithCompaniesInformation>
            <ContributorsWithCompaniesNamesContainer>
              <ContributorsWithCompaniesNames>
                {arrayToOxford(resource?.contributors?.companies?.map((company) => company.name))}
              </ContributorsWithCompaniesNames>
              {resource?.pulse_submission ? <PulseLeadIcon width={20} height={20} /> : null}
            </ContributorsWithCompaniesNamesContainer>
            {resource?.started_at || resource?.released_at ? (
              <ContributorsWithCompaniesDate>
                {resource?.started_at ? dayjs(resource.started_at).format('MMM YYYY') : null}
                {resource?.released_at && <> - {dayjs(resource.released_at).format('MMM YYYY')}</>}
              </ContributorsWithCompaniesDate>
            ) : null}
          </ContributorsWithCompaniesInformation>
        </ContributorsWithCompaniesCompanyWrapper>
      </ContributorsWithCompaniesWrapper>
    </>
  );
}
